import React from 'react';
import { AppBar, Toolbar, IconButton, Badge, Typography, Box } from '@mui/material';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import { CartItem } from '../App';

interface MobileHeaderProps {
  cart: CartItem[];
  onCartClick: () => void;
  step: number;
  logoUrl: string;
}

export default function MobileHeader({ cart, onCartClick, step, logoUrl }: MobileHeaderProps) {
  // Only show on mobile and when we're on the product listing step (step 1)
  if (step !== 1) return null;

  const cartItemCount = cart.reduce((sum, item) => sum + item.quantity, 0);

  return (
    <AppBar
      position="sticky"
      sx={{
        display: { xs: 'block', md: 'none' }, // Mobile only
        bgcolor: 'white',
        color: 'text.primary',
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
        zIndex: 1100, // Above content but below dialogs
      }}
    >
      <Toolbar sx={{ minHeight: 44, px: 2, py: 0.5 }}>
        <Box component="img" src={logoUrl} alt="logo" sx={{ height: 32, mr: 1 }} />
        <Typography
          variant="h6"
          sx={{
            flexGrow: 1,
            fontWeight: 900,
            color: '#e6ac30',
            fontSize: '1rem',
            lineHeight: 1.2
          }}
        >
          Product List
        </Typography>

        <IconButton
          onClick={onCartClick}
          sx={{
            color: '#e6ac30',
            '&:hover': {
              bgcolor: 'rgba(230, 172, 48, 0.1)',
            }
          }}
          aria-label={`Cart with ${cartItemCount} items`}
        >
          <Badge
            badgeContent={cartItemCount}
            color="primary"
            sx={{
              '& .MuiBadge-badge': {
                bgcolor: '#e6ac30',
                color: 'white',
              }
            }}
          >
            <ShoppingCartIcon />
          </Badge>
        </IconButton>
      </Toolbar>
    </AppBar>
  );
}